import {AppState} from '../../../reducers/index';
import {createSelector} from '@ngrx/store';
import * as fromServiceDirectCostReducer from './service-direct-cost.reducer';

export const currentState = (state: AppState) => (state[fromServiceDirectCostReducer.serviceDirectCostsFeatureKey]);

export const selectAllServiceDirectCosts = createSelector(currentState, fromServiceDirectCostReducer.selectAll);

export const selectTotalServiceDirectCosts = createSelector(currentState, fromServiceDirectCostReducer.selectTotal);

export const selectModifiedServiceDirectCosts = createSelector(selectAllServiceDirectCosts, (serviceDirectCosts) => {
  return serviceDirectCosts.map((serviceDirectCost) => {
    return {
      ...serviceDirectCost
    };
  });
});
